"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    title: {
        marginBottom: theme.spacing(),
        marginTop: theme.spacing()
    },
    content: {
        textAlign: 'center',
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        width: '100% !important'
    },
    pageHeader: {
        marginTop: theme.spacing(),
        marginBottom: theme.spacing(4)
    },
    pageColumn: {
        height: '100%',
        backgroundColor: theme.palette.primary.contrastText.getLowEmphasis()
    },
    pageFooter: {
        marginBottom: theme.spacing(6)
    },
    pageFooterExtraNote: {
        marginBottom: theme.spacing(6),
        fontWeight: 600
    },
    card: {
        padding: theme.spacing(3)
    },
    columnHeader: {
        marginTop: theme.spacing(2),
        color: theme.palette.text.primary.getMediumEmphasis(),
        textAlign: 'center'
    },
    instructionImage: {
        [theme.breakpoints.down('lg')]: {
            width: '100%'
        },
        [theme.breakpoints.up('xl')]: {
            width: '98%'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=InviteScreenStyle.js.map